import { render, staticRenderFns } from "./MonthChart.vue?vue&type=template&id=39467c3c&scoped=true&"
import script from "./MonthChart.vue?vue&type=script&lang=js&"
export * from "./MonthChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39467c3c",
  null
  
)

export default component.exports